import "../css/detail.css";
import "../css/table.css";
import "../css/processDetail.css";
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  LOAD_MATCHINGLISTS_REQUEST,
  DELETE_MATCHINGLIST_REQUEST,
  ADD_MATCHINGLIST_REQUEST,
} from "../reducers/adminBusiness";
import { LOAD_ALLRESUMES_REQUEST } from "../reducers/adminIndividual";
import { LOAD_INDIVIDUAL_REQUEST } from "../reducers/adminUser";
import { hasValue, joinParts, orDash } from "../util/display";
const ProcessDetail = ({ onSelectMenu, data }) => {
  const dispatch = useDispatch();
  const { matchingLists, deleteMatchingListDone, loadMatchingListsDone } =
    useSelector((state) => state.adminBusiness);
  const { userIndividuals } = useSelector((state) => state.adminUser);
  const { allResumes } = useSelector((state) => state.adminIndividual);
  const businessId = data.businessId;
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const handleModal = (data) => {
    setModalData(data);
    setModalOpen(true);
  };
  const uniqueMatchingLists = Array.from(
    new Set(matchingLists.map((list) => list.id))
  ).map((id) => matchingLists.find((list) => list.id === id));
  console.log("uniqueMatchingLists : ", uniqueMatchingLists);
  useEffect(() => {
    dispatch({
      type: LOAD_MATCHINGLISTS_REQUEST,
      data: {
        businessId,
        applicationId: data.list.id,
      },
    });
    // 구직자 이름·주소·경력은 회원 데이터에서 가져오는데 그 요청이 빠져 있었습니다.
    dispatch({
      type: LOAD_INDIVIDUAL_REQUEST,
    });
  }, [dispatch, deleteMatchingListDone]);
  useEffect(() => {
    dispatch({
      type: LOAD_ALLRESUMES_REQUEST,
    });
  }, []);

  // 구직자가 이 화면을 보고 있는 동안 직접 동의/거절을 누를 수 있는데,
  // 예전엔 화면을 새로고침해야만 그 결과가 반영됐습니다. 일정 간격으로
  // 조용히 다시 불러와서, 새로고침 없이도 동의 현황이 갱신되게 합니다.
  useEffect(() => {
    const timer = setInterval(() => {
      dispatch({
        type: LOAD_MATCHINGLISTS_REQUEST,
        data: {
          businessId,
          applicationId: data.list.id,
        },
      });
    }, 8000);
    return () => clearInterval(timer);
  }, [dispatch, businessId, data.list.id]);

  let rank1, rank2, rank3, rank4;
  let rankList1, rankList2, rankList3, rankList4;

  const assignRank = (value, text) => {
    if (value === "1") {
      rank1 = text;
    } else if (value === "2") {
      rank2 = text;
    } else if (value === "3") {
      rank3 = text;
    } else if (value === "4") {
      rank4 = text;
    }
  };

  assignRank(data.list.business_application_rank1, "근무시작 가능 시기");

  if (rank1 === "근무시작 가능 시기") {
    assignRank(data.list.business_application_rank2, "경력");
    assignRank(data.list.business_application_rank3, "근무형태");
    assignRank(data.list.business_application_rank4, "거주지");
  } else {
    assignRank(data.list.business_application_rank2, "경력");
    assignRank(data.list.business_application_rank3, "근무형태");
    assignRank(data.list.business_application_rank4, "거주지");
  }

  function assignRankList(rank, data) {
    if (rank === "경력") {
      let career = "";
      if (data.list.business_application_career === "신입") {
        career = "신입";
      } else if (data.list.business_application_career === "관계없음") {
        career = "관계없음";
      } else {
        // 예전엔 존재하지 않는 필드(business_application_career1)를 읽고
        // 있어서 항상 "undefined년"으로 표시됐습니다. 실제로 저장되는
        // 필드는 최소·최대 경력(careerMin/careerMax)입니다.
        const min = data.list.business_application_careerMin;
        const max = data.list.business_application_careerMax;
        if (min && max) {
          career = `${min}년 ~ ${max}년`;
        } else if (min) {
          career = `${min}년 이상`;
        } else if (max) {
          career = `${max}년 이하`;
        } else {
          career = "-";
        }
      }
      return career;
    }
    return null;
  }

  rankList1 = assignRankList(rank1, data);

  if (rank1 === "경력") {
    rankList2 = assignRankList(rank2, data);

    if (rank2 === "근무시작 가능 시기") {
      rankList2 = `${data.list.business_application_startYear}년 ${data.list.business_application_startMonth}월`;

      if (rank3 === "근무형태") {
        let workType = "";
        if (data.list.business_application_workPlace === "출근·재택 병행") {
          workType = "모두가능";
        } else if (
          data.list.business_application_workPlace === "재택 근무 가능"
        ) {
          workType = "재택";
        } else if (
          data.list.business_application_workPlace ===
          "사업자 주소와 동일 (출근)"
        ) {
          workType = "출퇴근";
        }
        rankList3 = workType;

        if (rank4 === "거주지") {
          rankList4 = data.business.business_member_jibunAddress;
        }
      }
    }
  } else if (rank2 === "경력") {
    rankList2 = assignRankList(rank2, data);
  }

  const deleteList = useCallback(
    (e, id, cnt) => {
      const isConfirmed = window.confirm("삭제하시겠습니까?");
      const newCnt = cnt - 1;
      setUserCnt(newCnt);
      if (isConfirmed) {
        e.preventDefault();
        dispatch({
          type: DELETE_MATCHINGLIST_REQUEST,
          data: {
            id,
            newCnt,
          },
        });
      }
    },
    [dispatch]
  );

  const addList = useCallback(
    (e, id, cnt) => {
      const isConfirmed = window.confirm("추가하시겠습니까?");
      const newCnt = Number(cnt) + 1;
      setUserCnt(String(newCnt));
      if (isConfirmed) {
        e.preventDefault();
        dispatch({
          type: ADD_MATCHINGLIST_REQUEST,
          data: {
            id,
            newCnt,
          },
        });
      }
    },
    [dispatch]
  );

  // 채용이 확정된 구직자가 누구인지 (회원번호 → 이름)
  const hiredIndividualId = data.list.hiredIndividualId;
  const isHiredPerson = (individualId) =>
    Boolean(hiredIndividualId) &&
    String(hiredIndividualId) === String(individualId);
  const hiredName =
    (userIndividuals &&
      userIndividuals.find(
        (user) => String(user.IndividualId) === String(hiredIndividualId)
      )?.user_member_name) ||
    `회원번호 ${hiredIndividualId}`;

  const [userCnt, setUserCnt] = useState(data.list.individualCnt);
  console.log("userCnt : ", userCnt);
  let agreeCnt = 0;

  // --- 확정 / 기간연장 ---
  const [deadline, setDeadline] = useState(data.list.responseDeadline);
  const [processing, setProcessing] = useState(false);

  // 테스트용: 구직자 대신 동의/거절을 처리합니다.
  // 한 컴퓨터에서 기업 계정과 구직자 계정을 동시에 열기 어려워, 테스트할 때만
  // 쓰는 임시 기능입니다. 정식 오픈 전에는 이 버튼을 없애야 합니다.
  const setConcurrenceForTest = async (individualId, agreement) => {
    const isConfirmed = window.confirm(
      `[테스트용] 이 구직자를 "${agreement}" 처리합니다.\n실제로는 구직자가 직접 눌러야 하는 항목입니다. 계속할까요?`
    );
    if (!isConfirmed) return;
    setProcessing(true);
    try {
      await axios.post("/matching/admin/setConcurrence", {
        applicationId: data.list.id,
        individualId,
        agreement,
      });
      alert(`${agreement} 처리되었습니다.`);
      window.location.reload();
    } catch (error) {
      alert(
        error.response?.data?.message || "처리 중 오류가 발생했습니다."
      );
    } finally {
      setProcessing(false);
    }
  };

  const finalizeList = async () => {
    const isConfirmed = window.confirm(
      "확정하면 기업이 목록을 확인할 수 있게 됩니다. 계속할까요?"
    );
    if (!isConfirmed) return;
    setProcessing(true);
    try {
      await axios.post(`/matching/admin/finalize/${data.list.id}`);
      alert("확정되었습니다.");
      window.location.reload();
    } catch (error) {
      alert("확정 중 오류가 발생했습니다.");
    } finally {
      setProcessing(false);
    }
  };

  const extendDeadline = async () => {
    const input = window.prompt(
      "새 마감일을 YYYY-MM-DD 형식으로 입력하세요. (비워두면 기존 마감일에서 2일 연장)",
      ""
    );
    // 사용자가 취소를 누르면 input이 null이라 아무 것도 안 합니다.
    if (input === null) return;
    setProcessing(true);
    try {
      const result = await axios.post(
        `/matching/admin/extend/${data.list.id}`,
        input ? { newDeadline: input } : {}
      );
      setDeadline(result.data.newDeadline);
      alert(`마감일이 ${result.data.newDeadline}로 연장되었습니다.`);
    } catch (error) {
      alert("연장 중 오류가 발생했습니다.");
    } finally {
      setProcessing(false);
    }
  };

  const markPaid = async () => {
    const isConfirmed = window.confirm(
      "실제 결제 없이 '결제완료' 상태로 바꿉니다. 테스트용입니다. 계속할까요?"
    );
    if (!isConfirmed) return;
    setProcessing(true);
    try {
      await axios.post(`/matching/admin/markPaid/${data.list.id}`);
      alert("결제완료 처리되었습니다.");
      window.location.reload();
    } catch (error) {
      alert("처리 중 오류가 발생했습니다.");
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="detail processDetail">
      <div className="detail_container">
        <div
          className="back_btn"
          onClick={() => {
            onSelectMenu(data.previousComponent);
          }}
        >
          돌아가기
        </div>
        <div className="user_box">
          <p>회사명 : {data.business.business_member_companyName}</p>
          <p>채용제목 : {data.list.business_application_name}</p>
        </div>
        <div className="title">현재 단계 : {data.list.progressStep}</div>
        {data.list.hireResult && (
          <div className="user_box">
            <p
              style={{
                color: data.list.hireResult === "채용완료" ? "#2196F3" : "#999",
                fontWeight: 600,
              }}
            >
              채용 결과: {data.list.hireResult}
              {/* 예전엔 회원번호만 보여줬는데, 이 화면에서는 번호만으로
                  누구인지 알 수가 없었습니다. 아래 표에 있는 이름을 찾아
                  함께 보여줍니다. */}
              {data.list.hiredIndividualId && ` (${hiredName})`}
            </p>
          </div>
        )}
        {data.list.progressStep === "조사완료" && (
          <div className="user_box">
            <button disabled={processing} onClick={markPaid}>
              (테스트용) 결제완료로 바로 전환
            </button>
          </div>
        )}
        {(data.list.progressStep === "동의여부조사중" ||
          data.list.progressStep === "조사완료") && (
          <div
            className="user_box"
            style={{ display: "flex", alignItems: "center", gap: "1vw" }}
          >
            <p>응답 마감일 : {deadline || "미설정"}</p>
            <p>
              지금까지 동의: {matchingLists.filter((l) => l.concurrence === "동의").length}명
            </p>
            <button disabled={processing} onClick={finalizeList}>
              확정 (기업에 목록 열어주기)
            </button>
            <button disabled={processing} onClick={extendDeadline}>
              기간 연장
            </button>
          </div>
        )}
        <p className="rank">채용 우선순위</p>
        <div className="rank_box">
          <p>1위</p>
          <p>{rank1}</p>
          <p>{rankList1}</p>
        </div>
        <div className="rank_box">
          <p>2위</p>
          <p>{rank2}</p>
          <p>{rankList2}</p>
        </div>
        <div className="rank_box">
          <p>3위</p>
          <p>{rank3}</p>
          <p>{rankList3}</p>
        </div>
        <div className="rank_box">
          <p>4위</p>
          <p>{rank4}</p>
          <p>{rankList4}</p>
        </div>
        <p className="rank">매칭된 구직자 리스트</p>
        <div className="table_container">
          <div className="row row_head">
            <p>No</p>
            <p>이름</p>
            <p>주소</p>
            <p>근무형태</p>
            <p>시작시기</p>
            <p>경력</p>
            <p>매칭점수</p>
            <p></p>
            <p></p>
          </div>
          {uniqueMatchingLists &&
            uniqueMatchingLists
              .slice(0, 15)
              .filter((list) => Number(list.BusinessId) === businessId)
              .map((list, index) => {
                const user =
                  userIndividuals &&
                  userIndividuals.find(
                    (user) => user.IndividualId === Number(list.IndividualId)
                  );
                const resume =
                  allResumes &&
                  allResumes.find(
                    (user) => user.IndividualId === Number(list.IndividualId)
                  );
                const backgroundColor =
                  list && list.concurrence === "대기"
                    ? "#F5F2EB"
                    : list && list.concurrence === "동의"
                    ? "#CABD99"
                    : list && list.concurrence === "거절"
                    ? "#C8C8C8"
                    : "initial";
                if (list.concurrence === "동의") {
                  agreeCnt++;
                }
                console.log("index : ", index);
                console.log("agreeCnt : ", agreeCnt);
                if (list.showOn !== "off") {
                  return (
                    <div
                      className={
                        index % 2 === 0
                          ? "content_row row"
                          : "content_row row even"
                      }
                      key={index}
                    >
                      <p style={{ backgroundColor }}>{index + 1}</p>
                      <p style={{ backgroundColor }}>{user?.user_member_name}</p>
                      <p style={{ backgroundColor }}>
                        {user?.user_member_jibunAddress}
                      </p>
                      <p style={{ backgroundColor }}>
                        {user?.user_member_workType}
                      </p>
                      {/* 값이 없을 때 "2026년 9월 일"처럼 빈칸이 남던 것을
                          고쳤습니다. */}
                      <p style={{ backgroundColor }}>
                        {joinParts([
                          [resume?.user_resume_hopeStartYear, "년"],
                          [resume?.user_resume_hopeStartMonth, "월"],
                          [resume?.user_resume_hopeStartDay, "일"],
                        ])}
                      </p>
                      {/* 경력이 비어 있으면 "개월"만 남던 것을 고쳤습니다. */}
                      <p style={{ backgroundColor }}>
                        {hasValue(user?.user_member_career)
                          ? `${user.user_member_career}개월`
                          : "-"}
                      </p>
                      <p style={{ backgroundColor }}>{list.point}점</p>
                      <p
                        className="btn"
                        onClick={() => {
                          handleModal(user);
                        }}
                      >
                        연락처
                      </p>
                      {isHiredPerson(list.IndividualId) ? (
                        // 이 공고에서 최종 채용이 확정된 구직자입니다.
                        // "동의"보다 한 단계 더 나아간 상태이므로 따로 표시합니다.
                        <p
                          className="btn"
                          style={{
                            cursor: "default",
                            backgroundColor: "#1565c0",
                            color: "white",
                            fontWeight: 700,
                          }}
                        >
                          확정
                        </p>
                      ) : list.concurrence === "대기" ? (
                        // 테스트용: 구직자 계정으로 직접 로그인하지 않아도
                        // 여기서 동의 처리를 대신할 수 있습니다.
                        <p
                          className="btn"
                          title="테스트용 - 구직자 대신 동의 처리"
                          onClick={() =>
                            setConcurrenceForTest(list.IndividualId, "동의")
                          }
                        >
                          응답대기
                        </p>
                      ) : userCnt <= 5 && userCnt >= index + 1 ? (
                        // 노출 대상 후보입니다. "삭제"라고만 뜨면 이 사람이
                        // 동의했는지 거절했는지 알 수 없었습니다. 동의/거절
                        // 상태를 보여주고, 눌러서 노출 목록에서 빼는 기능은
                        // 그대로 둡니다.
                        <p
                          className="btn"
                          title="눌러서 노출 목록에서 뺄 수 있습니다."
                          onClick={(e) => {
                            deleteList(e, list.id, userCnt);
                          }}
                        >
                          {list.concurrence === "동의" ? "동의" : "거절"}
                        </p>
                      ) : list.showOn === "on" ? (
                        <p
                          className="btn"
                          title="눌러서 노출 목록에서 뺄 수 있습니다."
                          onClick={(e) => {
                            deleteList(e, list.id, userCnt);
                          }}
                        >
                          {list.concurrence === "동의" ? "동의" : "거절"}
                        </p>
                      ) : list.concurrence === "동의" ? (
                        // 이미 동의한 구직자입니다. 예전엔 "추가"라고만 떠서
                        // 동의했는지 여부를 알 수 없었습니다. 눌러서 노출
                        // 목록에 추가하는 기능은 그대로 두고, 이름만
                        // 상태를 알 수 있게 바꿨습니다.
                        <p
                          className="btn"
                          title="동의한 구직자입니다. 눌러서 노출 목록에 추가할 수 있습니다."
                          onClick={(e) => {
                            addList(e, list.id, userCnt);
                          }}
                        >
                          동의함
                        </p>
                      ) : (
                        // 거절한 구직자는 노출 목록에 추가할 대상이 아니므로
                        // 상태만 보여주고 클릭 동작은 두지 않습니다.
                        <p className="btn" style={{ cursor: "default" }}>
                          거절함
                        </p>
                      )}
                      {/* {userCnt > agreeCnt && list.showOn === "on" ? (
                        <p
                          className="btn"
                          onClick={(e) => {
                            deleteList(e, list.id, userCnt);
                          }}
                        >
                          삭제
                        </p>
                      ) : list.showOn === "on" ? (
                        <p
                          className="btn"
                          onClick={(e) => {
                            deleteList(e, list.id, userCnt);
                          }}
                        >
                          삭제
                        </p>
                      ) : list.concurrence === "동의" ? (
                        <p
                          className="btn"
                          onClick={(e) => {
                            addList(e, list.id, userCnt);
                          }}
                        >
                          추가
                        </p>
                      ) : (
                        <p className="btn">응답대기</p>
                      )} */}
                    </div>
                  );
                }
              })}
        </div>
      </div>
      {modalOpen && modalData && (
        <div className="modal">
          <p>이름 : {modalData.user_member_name}</p>
          <p>연락처 : {modalData.user_member_tel}</p>
          <p>이메일 : {modalData.user_member_email}</p>
          <button
            onClick={() => {
              setModalOpen(false);
            }}
          >
            확인
          </button>
        </div>
      )}
    </div>
  );
};

export default ProcessDetail;
